import { wrapFunction } from 'owa-performance/lib/utils/wrapFunction';
import { hasQueryStringParameter } from 'owa-querystring';

const timings = {};

/**
 * Function to measure perf of a single method and put it in timings object
 */
/* eslint-disable-next-line @typescript-eslint/no-explicit-any --
 * See aka.ms/mini-lint-errors
 *	> Unexpected any. Specify a different type. */
export function measureFunctionPerf(func: any, name: string) {
    let initialTime = 0;
    return wrapFunction(
        func,
        () => {
            initialTime = performance.now();
        },
        () => {
            const endTime = performance.now();
            timings[name] = endTime - initialTime;
            timings[name + '_s'] = initialTime;
            timings[name + '_e'] = endTime;
            if (hasQueryStringParameter('timing')) {
                const timingLabel = '_timings';
                window[timingLabel] = window[timingLabel] || {};
                window[timingLabel][name] = timings[name];
                window[timingLabel][name + '_s'] = initialTime;
                window[timingLabel][name + '_e'] = endTime;
            }
        }
    );
}

export function getTiming(name: string) {
    return timings[name];
}
